import {
  FETCH_CATEGORY_GROUPS_REQUEST,
  FETCH_CATEGORY_GROUPS_SUCCESS,
  FETCH_CATEGORY_GROUPS_FAILURE,
  ADD_CATEGORY_GROUP_REQUEST,
  ADD_CATEGORY_GROUP_SUCCESS,
  ADD_CATEGORY_GROUP_FAILURE,
  UPDATE_CATEGORY_GROUP_REQUEST,
  UPDATE_CATEGORY_GROUP_SUCCESS,
  UPDATE_CATEGORY_GROUP_FAILURE,
  DELETE_CATEGORY_GROUP_REQUEST,
  DELETE_CATEGORY_GROUP_SUCCESS,
  DELETE_CATEGORY_GROUP_FAILURE,
  SET_CATEGORY_GROUP_EDIT,
  CLEAR_CATEGORY_GROUP_EDIT,
} from '../../../../types/masters/styles/categoryGroup/categoryGroupTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingCategoryGroup: null,
};

const categoryGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATEGORY_GROUPS_REQUEST:
    case ADD_CATEGORY_GROUP_REQUEST:
    case UPDATE_CATEGORY_GROUP_REQUEST:
    case DELETE_CATEGORY_GROUP_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CATEGORY_GROUPS_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_CATEGORY_GROUP_SUCCESS:
    case UPDATE_CATEGORY_GROUP_SUCCESS:
    case DELETE_CATEGORY_GROUP_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_CATEGORY_GROUPS_FAILURE:
    case ADD_CATEGORY_GROUP_FAILURE:
    case UPDATE_CATEGORY_GROUP_FAILURE:
    case DELETE_CATEGORY_GROUP_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_CATEGORY_GROUP_EDIT:
      return { ...state, editingCategoryGroup: action.payload };
    case CLEAR_CATEGORY_GROUP_EDIT:
      return { ...state, editingCategoryGroup: null };
    default:
      return state;
  }
};

export default categoryGroupReducer; 